<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="6">
                    <rkm-form-input-autocomplete
                        :fields="fields.cliente"
                        :repository="repositories.cadastro.limiteMensagem"
                        :request-params="id ? {limite_id: id} : {}"
                        :selected-text="model.cliente_nome"
                        :validations="validations.cliente"
                        label="Cliente"
                        v-model="model.cliente_id"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-input
                        :validations="validations.limite_mensal"
                        label="Limite mensal"
                        placeholder="Quantidade de mensagens"
                        type="number"
                        v-model="model.limite_mensal"
                    />
                </rkm-col>

                <rkm-col cols="3">
                    <rkm-form-select
                        :validations="validations.ativo"
                        label="Integração WhatsApp ativa"
                        show-default-option
                        v-model="model.ativo"
                    >
                        <rkm-form-select-option :value="true">Sim</rkm-form-select-option>
                        <rkm-form-select-option :value="false">Não</rkm-form-select-option>
                    </rkm-form-select>
                </rkm-col>
            </rkm-row>

            <rkm-alert color="info" show>
                Ao ativar a integração, o ConectaSUS disponibiliza o consentimento para mensagens por WhatsApp.
                O consumo é contabilizado pelo Engine e uma nova competência começa automaticamente no primeiro dia de cada mês.
            </rkm-alert>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        fields() {
            return {
                cliente: [
                    {key: 'nome', name: 'cadastro_cliente.nome'},
                ],
            }
        },
        loading() {
            return this.getLoading('cadastro-limite-mensagem-form')
        },
        validations() {
            return {
                cliente: {required: true},
                limite_mensal: {
                    required: true,
                    numeric: true,
                    min_value: 1,
                },
                ativo: {required: true},
            }
        },
    },
    data: () => ({
        model: {
            cliente_id: null,
            cliente_nome: null,
            limite_mensal: null,
            ativo: true,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (!this.id) {
                return
            }

            this.setLoading('cadastro-limite-mensagem-form')
            this.repositories.cadastro.limiteMensagem.edit(this.id)
                .then(({data}) => {
                    this.model = data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading('cadastro-limite-mensagem-form'))
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (!validated) {
                        return
                    }

                    this.setLoading('cadastro-limite-mensagem-form')

                    const request = {
                        cliente_id: this.model.cliente_id,
                        limite_mensal: this.model.limite_mensal,
                        ativo: this.model.ativo,
                    }
                    const save = this.id
                        ? this.repositories.cadastro.limiteMensagem.update(request, this.id)
                        : this.repositories.cadastro.limiteMensagem.store(request)

                    save
                        .then(({data}) => this.$emit('save', data))
                        .catch(this.handleError)
                        .finally(() => this.unsetLoading('cadastro-limite-mensagem-form'))
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>
